import React from 'react';
import { motion } from 'framer-motion';

const technologies = [
  // Frontend
  {
    name: 'Flutter',
    category: 'Frontend Development',
    description: 'Cross-platform mobile app development framework'
  },
  // Backend
  {
    name: 'Python',
    category: 'Backend Development',
    description: 'Core backend programming language'
  },
  {
    name: 'Starlette',
    category: 'Backend Development',
    description: 'High-performance async Python framework'
  },
  // Infrastructure
  {
    name: 'AWS',
    category: 'Cloud Infrastructure',
    description: 'Scalable cloud infrastructure and services'
  },
  {
    name: 'Firebase',
    category: 'Cloud Infrastructure',
    description: 'Real-time data and authentication'
  },
  // Integration
  {
    name: 'OpenSearch',
    category: 'Search & Analytics',
    description: 'Advanced search and analytics engine'
  },
  // Content Management
  {
    name: 'Contentful',
    category: 'Content Management',
    description: 'Headless CMS for dynamic content'
  },
  // Business Systems
  {
    name: 'Microsoft Dynamics CRM',
    category: 'Business Systems',
    description: 'Customer relationship management'
  },
  // Mapping
  {
    name: 'Mapbox',
    category: 'Mapping & Navigation',
    description: 'Location services and interactive mapping'
  },
  // Project Management
  {
    name: 'JIRA',
    category: 'Project Management',
    description: 'Agile development tracking'
  }
];

const ProjectTechStack = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <span className="inline-block text-accent mb-4">Technology Stack</span>
            <h2 className="text-3xl md:text-4xl font-display font-semibold text-gray-900 mb-6">
              Powered by Modern Technologies
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              A carefully selected stack of cutting-edge technologies that ensures scalability,
              performance, and exceptional user experience.
            </p>
          </motion.div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
            {technologies.map((tech, index) => (
              <motion.div
                key={tech.name}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="text-center group"
              >
                <h3 className="text-xl font-display font-semibold text-gray-900 mb-2 group-hover:text-accent transition-colors duration-300">
                  {tech.name}
                </h3>
                <p className="text-accent text-sm mb-2">
                  {tech.category}
                </p>
                <p className="text-gray-600 text-sm">
                  {tech.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectTechStack;